import { useState, type FormEvent, type ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { loginSchema } from '@kn/shared';
import { useAuth } from '../auth/auth-context';
import { messageErreur } from '../api/error-message';
import { useTitrePage } from '../hooks/useTitrePage';

export function LoginPage(): ReactElement {
  // Hors de la coquille : la page ecrit elle-meme son titre.
  useTitrePage('Connexion');
  const { user, isLoading, login } = useAuth();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  if (isLoading) {
    return <p className="chargement">Chargement...</p>;
  }

  if (user) {
    const cible = (location.state as { from?: string } | null)?.from ?? '/tableau-de-bord';
    return <Navigate to={user.mustChangePassword ? '/changer-mot-de-passe' : cible} replace />;
  }

  async function handleSubmit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    setErreur(null);

    const parsed = loginSchema.safeParse({ email, password: motDePasse });
    if (!parsed.success) {
      setErreur(parsed.error.issues[0]?.message ?? 'Formulaire invalide.');
      return;
    }

    setEnCours(true);
    try {
      await login(parsed.data);
    } catch (error) {
      setErreur(messageErreur(error));
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className="page-connexion">
      <div className="carte page-connexion__carte">
        <h1>Connexion</h1>
        <p className="sous-titre">Journal douane / accises &mdash; Kuehne &amp; Nagel</p>

        {erreur && (
          <p className="alerte alerte--erreur" role="alert">
            {erreur}
          </p>
        )}

        <form onSubmit={(event) => void handleSubmit(event)} noValidate>
          <label className="champ" htmlFor="email">
            <span>Adresse e-mail</span>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </label>

          <label className="champ" htmlFor="motDePasse">
            <span>Mot de passe</span>
            <input
              id="motDePasse"
              name="motDePasse"
              type="password"
              autoComplete="current-password"
              value={motDePasse}
              onChange={(event) => setMotDePasse(event.target.value)}
            />
          </label>

          <button type="submit" className="bouton" disabled={enCours}>
            {enCours ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}
